import { BaseError } from '../base';

export class APIError extends BaseError {
  status: number;

  constructor(message: string, code: string, status: number) {
    super({
      cause: null,
      code,
      docsUrl: null,
      name: 'APIError',
      shortMessage: message,
    });

    this.status = status;
  }

  static async fromResponse(response: Response) {
    try {
      const errorBody = await response.clone().json();

      if (
        errorBody &&
        'error' in errorBody &&
        typeof errorBody.error === 'string'
      ) {
        const errorCode =
          'code' in errorBody && typeof errorBody.code === 'string'
            ? errorBody.code
            : 'unknown_error';

        return new APIError(errorBody.error, errorCode, response.status);
      }

      return null;
    } catch {
      return null;
    }
  }
}
